
import React from 'react'
//@ts-ignore
import s from './MainMenu.module.scss'
import { useDispatch, useSelector } from "react-redux";
import { getKeySectionActive, getListSection } from '../../../store/selectors/selectors';
import { itemMenu } from '../../../utils/listGlobalMenu';
import { setMainStep } from '../../../store/actions/setting';
//@ts-ignore
import { getUrlImg } from '../../../utils/utilsFunctions';


export const MenuMain = () => {

    const dispatch = useDispatch();

    const listMainMenu: itemMenu[] = useSelector(getListSection)
    const keySectionActive: string = useSelector(getKeySectionActive);

    const onSelectItem = (item: itemMenu) => {
        dispatch(setMainStep(item['key']))
    }


    return (

        <div className={s.menu}>
            {listMainMenu.map((item: itemMenu) => {

                let isActive = item['key'] === keySectionActive;

                let menuItem = `${s.item}`
                if (isActive) menuItem += ` ${s.active}`

                let urlSVG = item['imgUrl']
                if (isActive) urlSVG = item['imgUrlActive'];

                return (
                    <div key={item['key']} className={menuItem} onClick={() => onSelectItem(item)}>
                        <div className={s.menu__item}>
                            <div className={s.img}>
                                <img src={getUrlImg(urlSVG)} alt="" />
                            </div>
                            <div className={s.title}>{item['name']}</div>
                        </div>
                    </div>
                )
            })}
        </div>

    )
}